(() => {

/*
custom events: 
  size_chart_open
  filter_list
  sort_list
  header_navigation_click
  navigation_click_mens
  navigation_click_womens
  navigation_click_classicstyles
  navigation_click_newarrivals
  navigation_click_collections
  subnav_click_shop
  subnav_click_lookbook
  subnav_click_campaign
*/

  if(typeof gtag == 'undefined') return;


  // size_chart_open
  const customEvents = [
    {
      event: 'size_chart_open',
      element: '.size-chart-button',
      props: {
        'url': window.location.pathname
      }
    },
  ];

  function elementClickEvent(event, element, props){
    // console.log('element', element)
    document.querySelectorAll(element).forEach( el => {
      el.addEventListener('click', e => {
        gtag('event', event, props);
        //console.log('event', event, 'props', props)
      })
    })
  }

  customEvents.forEach( ev => {
    elementClickEvent(ev.event, ev.element, ev.props);
  })


  // header_navigation_click
  document.querySelectorAll('#header-group a').forEach(a => {
    a.addEventListener('click', e => {
      //console.log('header_navigation_click')

      // header_navigation_click_mens
      gtag('event', 'header_navigation_click', {
        'link_title': a.innerText,
        'to': a.href.replace('https://fearofgod.com',''),
        'from': window.location.href.replace('https://fearofgod.com',''),
      }); 

      // navigation_click_mens
      if(a.href.includes('/mens-') || 'fearofgod-suiting'){
        //console.log('navigation_click_mens a', a)
        gtag('event', 'navigation_click_mens', {
          'link_title': a.innerText,
          'to': a.href.replace('https://fearofgod.com',''),
          'from': window.location.href.replace('https://fearofgod.com',''),
        }); 
      }

      // navigation_click_womens
      if(a.href.includes('/womens-') || '/all-womens'){
        //console.log('navigation_click_womens a', a)
        gtag('event', 'navigation_click_womens', {
          'link_title': a.innerText,
          'to': a.href.replace('https://fearofgod.com',''),
          'from': window.location.href.replace('https://fearofgod.com',''),
        }); 
      }

      // navigation_click_classicstyles
      if(a.href.includes('/classic-styles')){
        gtag('event', 'navigation_click_classicstyles', {
          'link_title': a.innerText,
          'to': a.href.replace('https://fearofgod.com',''),
          'from': window.location.href.replace('https://fearofgod.com',''),
        }); 
      }

      // navigation_click_newarrivals
      if(a.href.includes('/classic-styles')){
        gtag('event', 'navigation_click_newarrivals', {
          'link_title': a.innerText,
          'to': a.href.replace('https://fearofgod.com',''),
          'from': window.location.href.replace('https://fearofgod.com',''),
        }); 
      }

    })
  });


  // navigation_click_collections
  [...document.getElementsByClassName('menu-list__list-item')].forEach( li => {
    if(li.getElementsByClassName('menu-list__link-title').length){
      if(li.getElementsByClassName('menu-list__link-title')[0].innerHTML.toLowerCase() == "collections"){
        [...li.getElementsByTagName('a')].forEach( a => {
          a.addEventListener('click', e => {
            gtag('event', 'navigation_click_collections', {
              'link_title': a.innerText,
              'to': a.href.replace('https://fearofgod.com',''),
              'from': window.location.href.replace('https://fearofgod.com',''),
            }); 
          })
        })
      }
    }
  })


  // footer_navigation_click
  document.querySelectorAll('.shopify-section-group-footer-group a')?.forEach( a => {
    a.addEventListener('click', e => {
      //console.log('footer_navigation_click')
      gtag('event', 'footer_navigation_click', {
        'link_title': a.innerText,
        'to': a.href.replace('https://fearofgod.com',''),
        'from': window.location.href.replace('https://fearofgod.com',''),
      }); 
    })
  });


  // header_navigation_click
  //document.querySelectorAll('#header-group a').forEach(a => {
    //a.addEventListener('click', e => {
      //// console.log('navigation_click a', a)
      //if(a.href.includes('/mens-') || 'fearofgod-suiting'){
        //// console.log('mens_navigation_click a', a)
        //gtag('event', 'header_navigation_click_mens', {
          //'link_title': a.innerText,
          //'to': a.href.replace('https://fearofgod.com',''),
          //'from': window.location.href.replace('https://fearofgod.com',''),
        //}); 
      //}
    //})
  //});


  // filter_list
  document.querySelectorAll('.facets__inputs-list-item')?.forEach(el => {
    el.addEventListener('click', e => {
      // console.log('filter_list', el.querySelector('.checkbox__label-text')?.innerText)
      gtag('event', 'filter_list', {
        'url': window.location.pathname,
        'filter': el.querySelector('.checkbox__label-text')?.innerText
      }); 
    })
  });


  // sort_list
  document.querySelectorAll('.sorting-filter__option')?.forEach(el => {
    el.addEventListener('click', e => {
      // console.log('sort_list', el.querySelector('.checkbox__label-text')?.innerText)
      gtag('event', 'sort_list', {
        'url': window.location.pathname,
        'sort_order': el.querySelector('.checkbox__label-text')?.innerText
      }); 
    })
  });

  // submenu
  document.querySelectorAll('.collection-submenu').forEach( submenu => {
    submenu.querySelectorAll('a').forEach( a => {
      let eventStr = null;
      if(a.innerText.toLowerCase().includes('shop')) {
        eventStr = 'subnav_click_shop';
      }

      if(a.innerText.toLowerCase().includes('lookbook')) {
        eventStr = 'subnav_click_lookbook';
      }

      if(a.innerText.toLowerCase().includes('campaign')) {
        eventStr = 'subnav_click_campaign';
      }

      if(eventStr){
        gtag('event', eventStr, {
          'url': window.location.pathname,
        }); 

      }
    })
  })

})();